const MessageComponent = ({ title }) => {
  return (
    <div>
      <h4>{title}</h4>
    </div>
  )
}

export default MessageComponent